import { render } from "./SpeechRecognition.vue?vue&type=template&id=81f19690&scoped=true"
import script from "./SpeechRecognition.vue?vue&type=script&lang=js"
export * from "./SpeechRecognition.vue?vue&type=script&lang=js"

import "./SpeechRecognition.vue?vue&type=style&index=0&id=81f19690&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81f19690"]])

export default __exports__